/**
 * Route for `igaming-kyc-hooks-external-for-player-vetting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingKycHooksExternalForPlayerVettingPage } from "../features/igaming-kyc-hooks-external-for-player-vetting/IgamingKycHooksExternalForPlayerVettingPage";

export const igamingKycHooksExternalForPlayerVettingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-kyc-hooks-external-for-player-vetting",
	component: IgamingKycHooksExternalForPlayerVettingPage,
});

export default igamingKycHooksExternalForPlayerVettingRoute;
